<template>
  <div class="mediaContainer" ref="videoParentElement">
    <template v-if="visibleMedia">
      <video
        v-if="resizeUpdateMedia()"
        autoplay=""
        muted=""
        loop=""
        playsinline=""
        ref="videobanner" 
        :class="{ scallingMedia: scallingmediaClass }"
      >
        <source
          ref="desktopSource"
          media="(min-width:1024px)"
          :src="desktopVideoSrc"
        />

        <source
          ref="mobileSource" 
          :src="mobileVideoSrc"
        />
      </video>

      <picture v-else :class="{ scallingMedia: scallingmediaClass }" >
        <source :data-srcset="desktopImgSrc" media="(min-width:1023px)" />

        <img
          class="lazy"
          :data-srcset="mobileImgSrc"
          :alt="desktopImgAlt"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        />
      </picture>
    </template>
  </div>
</template>

<script>
export default {
  name: 'webzineMagazineArticle',

  props: {
    desktopVideoSrc: {
      type: String,
    },
    mobileVideoSrc: {
      type: String,
    },
    desktopImgSrc: {
      type: String,
    },
    mobileImgSrc: {
      type: String,
    },
    desktopImgAlt: {
      type: String,
    },
    scallingmediaClass: {
      type: Boolean,
      required: false,
    },
    bannerindex: {
      type: Number,
    },
  },

  data() {
    return {
      smallScreen: window.matchMedia('(max-width: 1023px)').matches,
      visibleMedia: false,
    };
  },

  mounted() {
    window.addEventListener('resize', this.resizeUpdateMedia);
    window.addEventListener('scroll', this.checkScrollPosition);

    if (this.bannerindex === 0 && window.scrollY <= window.innerHeight) {
      this.visibleMedia = true;
    }
  },

  methods: {
    resizeUpdateArticleMedia(item) {
      if (!this.smallScreen && item?.mediaBlock?.desktopVideo?.src) {
        return true;
      } else if (this.smallScreen && item?.mediaBlock?.mobileVideo?.src) {
        return true;
      } else {
        return false;
      }
    },

    resizeUpdateMedia() {
      if (!this.smallScreen && this.desktopVideoSrc) {
        return true;
      } else if (this.smallScreen && this.mobileVideoSrc) {
        return true;
      } else {
        return false;
      }
    },
    checkScrollPosition() {
      if (window.scrollY > 200 && !this.visibleMedia) {
        this.visibleMedia = true;
      }
    },
  },

  destroyed() {
    window.removeEventListener('scroll', this.checkScrollPosition());
    window.removeEventListener('resize', this.resizeUpdateMedia());
  },
};
</script>
